import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { BaseService } from '../shared/base.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class FolderService extends BaseService {

    public getFolders(idToken: string, folderType: string) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/folders/${folderType}`, { headers });
    }
}